import { render, staticRenderFns } from "./DensityFormat.vue?vue&type=template&id=35710534"
import script from "./DensityFormat.vue?vue&type=script&lang=js"
export * from "./DensityFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports